import {PipelineStepStatusCode} from 'graphql-client/__generated/graphqlGlobalTypes';
import {isStepSucceeded} from 'pipelines/PipelineStepStatusUtils';
import {PipelineGraphQL} from 'pipelines/PipelineTypes';

export default function isAnalysisSucceeded(analysis: Pick<PipelineGraphQL, 'execution'>): boolean {
  return analysis.execution.steps.every(
    (step) => isStepSucceeded(step.statusCode) || step.statusCode === PipelineStepStatusCode.HALTED
  );
}
